// extracted by mini-css-extract-plugin
export default {"tag":"TagItem_tag__qqxC4"};